export const filtersId = '#filters-strip';
export const filterListingId = '#filters-listing';
export const listingId = '#list-wrapper';
export const productListingId = '#product-list-wrap';
export const firstFilterId = '#first-filter';
export const lastFilterId = '#last-filter';
export const headerId = '#header_id';

export const filterListingIdName = 'filters-listing';
export const listingIdName = 'list-wrapper';
export const productListingIdName = 'product-list-wrap';
export const firstFilterIdName = 'first-filter';
export const lastFilterIdName = 'last-filter';
export const filtersIdName = 'filters-strip';

export const titleId = 'title-listing';
export const sortId = 'filter-sort';
export const footerId = 'footer_id';


export const DEFAULT_RECT = { top: 0, bottom :0, left: 0, right: 0 };
export const staticHeight = '190px';
export const HEADER_FIXED_DISTANCE = 20;
export const SEARCH_BOTTOM_DISTANCE = 150;
export const defaultDims = {
  direction: 'down',
  viewportTop: 0,
  lastViewportTop: 0,
  top: 0,
  lastTop: 0,
  filtersHeight: 0,
  wrapperHeight: 0,
  headerHeight: 0,
  titleTop: 0,
  staticTop: 0,
};
